<app-header></app-header>
<app-sidebar></app-sidebar>
<main>
  <router-outlet></router-outlet>
</main>
